import {
    CLIENT_REPORT_BEGIN,
    CLIENT_REPORT_SUCCESS,
    CLIENT_REPORT_FAILURE,
} from 'app/actions/ClientReportActions';

const initialState = {
    data: [],
    isLoading: false,
};

export default function ClientReportReducer(state = initialState, action) {
    switch (action.type) {
        case CLIENT_REPORT_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case CLIENT_REPORT_SUCCESS:
            let data = action.payload.data.Data
            
            return {
                ...state,
                data,
                isLoading: false,
            };
        case CLIENT_REPORT_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        default:
            return state;
    }
};

export const getClientReport = state => {
    return state.data
}